export const SIMPLE_CONFIG_TYPES = {
  companies: { label: "Company", fields: ["name"] },
  categories: { label: "Category", fields: ["name", "short_code"] },
  salts: { label: "Salt", fields: ["name"] },
  "product-types": { label: "Product Type", fields: ["name"] },
  "item-types": { label: "Item Type", fields: ["name"] },
};
